import { FallbackError } from '../organisms/FallbackError';

const NotFound = () => {
  return (<FallbackError errorCode="404" errorText="Page inconnue" />) as React.ReactNode;
};

export default NotFound;
export { NotFound };
